export function AssemblyWorkInstructionStepsList({
  steps,
  className,
}: {
  steps: string[];
  className?: string;
}): JSX.Element | null {
  if (steps.length === 0) return null;
  return (
    <ol className={className ?? "list-decimal space-y-2 pl-5 text-sm text-slate-800"}>
      {steps.map((step, index) => (
        <li key={`${String(index)}-${step}`} className="leading-snug">
          {step}
        </li>
      ))}
    </ol>
  );
}
